// extracted by mini-css-extract-plugin
module.exports = {"CrfContent":"CrfContent_CrfContent__RBRY6","crf_content":"CrfContent_crf_content__mrert","addAction":"CrfContent_addAction__119ZA","btns_group":"CrfContent_btns_group__bqyWo"};